<form [formGroup]="editUserAccessGroupForm">
    @if (supplierAccessGroups) {
        <div class="inputGroup labelTop">
            <label for="listingAccessGroupsInput">{{ 'users.supplierUsers.edit.listingAccess.accessGroups' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error [parentForm]="editUserAccessGroupForm" [controlPath]="'listingAccessGroupsInput'" />
                <app-multi-select-input
                    id="listingAccessGroupsInput"
                    formControlName="listingAccessGroupsInput"
                    [optionsList]="supplierAccessGroups"
                    [idKey]="'id'"
                    [labelKey]="'name'"
                />
            </div>
        </div>
    }
</form>
